import styled from "styled-components";

export const Container = styled.main`
    background: #FFF;
    display: flex;
    flex-direction: column;
    overflow: auto;
    padding-bottom: 100px;
    padding-top: 75px;
    width: 100%;
    @media (min-width: 720px) {
        padding: 20px 120px 0 200px; /* [top] [right] [bottom] [left] */
    }
    @media (orientation: landscape) and (max-width: 1080px){
        gap: 20px;
        padding: 20px 20px 80px 20px;
    }
`;

export const ContainerSelect = styled.div`
    display: flex;
    flex: 0.2;
    justify-content: center;
    padding: 20px;
    width: 100%;
    @media (min-width: 720px) {
        justify-content: flex-start;
        padding: 0;
    }
`;

export const ContainerTop = styled.div`
    display: flex;
    flex: 0.8;
    flex-direction: column;
    justify-content: space-between;
    @media (min-width: 720px) {
        flex-direction: row;
        gap: 30px;
    }
`;

export const ContainerFocusCard = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    min-height: 320px;
    min-width: 350px;
    @media (orientation: landscape) and (max-width: 1080px){
        min-height: 280px;
        min-width: 300px;
    }
`;

export const ContainerCards = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    max-width: 615px;
    width: fit-content;
`;

export const ContainerBottom = styled.div`
    align-items: center;
    border: 1px solid #33CC99;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 1% 1% 15px 1%;
    padding: 10px 25px 0px 25px;
    width: 98%;
    @media (min-width: 720px) {
        width: 100%;
        margin: 0;
        margin-bottom: 15px;
    }
`;

export const DayIndicator = styled.div`
    align-items: center;
    align-self: center;
    background: #FFF;
    border-radius: 5px;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    display: flex;
    justify-content: center;
    margin-block: 20px;
    padding: 20px;
    width: 100%;
`;

export const StateText = styled.h2`
    color: #333;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media (min-width: 720px) {
        font-size: 24px;
    }
`;

export const StateContainer = styled.div`
    display: flex;
    width: 100%;
`;

export const StateMonthText = styled.h3`
    background: #FFF;
    border-radius: 5px;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: #333;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    padding: 8px;
    text-align: flex-start;
    @media (min-width: 720px) {
        font-size: 32.133px;
        padding: 15px 20px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: 15px;
        padding: 8px;
    }
`;

export const ContainerLeft = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 400px;
    width: 25%;
    @media (min-width: 720px) {
        justify-content: flex-start;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        min-width: 300px;
    }
`;

export const ContainerRight = styled.div`
    display: flex;
    flex-direction: column;
    @media (min-width: 720px) {
        flex-direction: row;
    }
`;

export const ContainerGraph = styled.div`
    display: flex;
    height: 250px;
    position: relative;
    width: 250px;
    @media (min-width: 720px) {
        height: 350px;
        width: 350px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 250px;
        width: 250px;
    }
`;

export const GraphTitle = styled.h1` 
    color: #333;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media (min-width: 720px) {
        margin-block: 40px;
    }
`;

export const LengendContainer = styled.div`
    align-items: center;
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    gap: 15px;
    height: auto;
    justify-content: center;
    @media (min-width: 720px) {
        align-items: center;
        flex-direction: row;
        gap: 5px;
        justify-content: flex-start;
        padding-bottom: 0px;
    }
`;

export const LegendButton = styled.div`
    background: #FFF;
    border: none;
    border-radius: 4px;
    box-shadow: 1.52px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: #333;
    display: flex;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    outline: none;
    padding: 5px;
    text-align: center;
    transition: 1s;
`;

export const LegendContent = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
    margin-left: 10px;
    transition: 1s;
    @media (min-width: 720px) {
        justify-content: flex-start;
    }
`;

export const LegendItem = styled.div`
    align-items: center;
    background: #FFF;
    border-radius: 3.676px;
    box-shadow: 1.52px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: #333;
    display: flex;
    flex-direction: row;
    gap: 8px;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    justify-content: center;
    line-height: normal;
    padding: 5px;
`;

export const LegendCircle = styled.div`
    align-items: center;
    background: ${props=>props.$background};
    border-radius: 50%;
    color: #F6F6F6;
    display: flex;
    height: 20px;
    justify-content: center;
    width: 20px;
`;